











import { Component, Vue } from 'vue-property-decorator';
import Contact from '@/views/contact/Contact.vue';

@Component({
    components: {
        Contact
    }
})
export default class Home extends Vue {
}
